import React from "react";
import { Autocomplete, Box, TextField } from "@mui/material";
import { ReactNode, useState } from "react";
import { useTranslation } from "react-i18next";

export interface IntervalSelectorProps {
  selectedInterval: string;
  setSelectedInterval: (newInterval: string) => void;

  isInline?: boolean;
  children?: ReactNode;

  includeTimeOfDayAndDayOfWeekOptions?: boolean;
}

export function IntervalSelector(props: IntervalSelectorProps): JSX.Element {
  const { i18n } = useTranslation();

  const [inputValue, setInputValue] = useState<string>('');

  const validIntervals = [
    { id: "__auto__", label: i18n.t("auto") },
    { id: "second", label: i18n.t("second") },
    { id: "minute", label: i18n.t("minute") },
    { id: "hour", label: i18n.t("hour") },
    { id: "day", label: i18n.t("day") },
    { id: "week", label: i18n.t("week") },
    { id: "month", label: i18n.t("month") },
    { id: "quarter", label: i18n.t("quarter") },
    { id: "year", label: i18n.t("year") }
  ];

  if (props.includeTimeOfDayAndDayOfWeekOptions) {
    validIntervals.push(
      { id: "time_of_day", label: i18n.t("time_of_day") },
      { id: "day_of_week", label: i18n.t("day_of_week") }
    );
  }

  return (
    <Box sx={{ display: props.isInline ? "inline-block" : "block", verticalAlign:"top", p:0, m:0 }}>
      <Autocomplete
        sx={{minWidth: "150px"}}
        options={validIntervals}
        inputValue={inputValue}
        onInputChange={(_, newInputValue) => {
          setInputValue(newInputValue);
        }}
        value={validIntervals.find(interval => interval.id === (props.selectedInterval ?? "__auto__")) || null}
        onChange={(event: React.SyntheticEvent, newValue: any) => {
          if (newValue && props.setSelectedInterval) {
            props.setSelectedInterval(newValue.id);
          }
        }}
        renderInput={(params) => <TextField autoComplete="off" {...params} />}
      />
    </Box>
  );
}
